import { Brand, Environment, MockSession, Session, Status, Type } from '@lendi/lala-react';

import { TEST_TOKEN } from '@funnels/constants';

export let session: Session;

export default function cookSession(
  useMock: boolean,
  sessionParams: {
    brand: Brand;
    type: Type;
    appEnv: Environment;
  }
) {
  const { brand, type, appEnv } = sessionParams;
  if (session) return { session };
  if (useMock) {
    // for temporary pass auth usage for user
    session = new MockSession();
    (session as MockSession).setToken(TEST_TOKEN);
    (session as MockSession).setStatus(Status.Authenticated);
  } else {
    session = new Session({
      brand,
      type,
      environment: appEnv,
    });
  }
  return { session };
}
